import type { FeatureFlags } from "../FeatureFlags";

export class AllFeatureFlags implements FeatureFlags<unknown> {
  isFeatureEnabled(): boolean {
    return true;
  }

  onFeatureFlagsUpdated(): void {
    // Do nothing
  }
}
